import React, { useEffect, useState } from 'react';
import pt from 'prop-types';
import cn from 'classnames';
import styles from './IncrementalButton.module.scss';

export default function IncrementalButton({ className, initialCount, maxValue, onDecrement, onIncrement, quantity }) {
  const [count, setCount] = useState(initialCount);

  useEffect(() => {
    setCount(initialCount);
  }, [initialCount]);

  const handleDecrement = () => {
    setCount((prev) => Math.max(prev - 1, 0));
    onDecrement();
  };

  const handleIncrement = () => {
    setCount(((prev) => {
      const next = prev + 1;

      if (maxValue && (next > maxValue)) return prev;

      onIncrement();
      return next;
    }));
  };

  return (
    <div className={cn(styles.incrementalBtnsWrapper, className)}>
      <button onClick={handleDecrement} type="button">-</button>
      {quantity ? (
        <span>{count > 0 ? quantity : count}</span>
      ) : (
        <span>{count}</span>
      )}
      <button onClick={handleIncrement} type="button">+</button>
    </div>
  );
}

IncrementalButton.defaultProps = {
  className: '',
  initialCount: 0,
  maxValue: Number.POSITIVE_INFINITY,
  onDecrement: () => {},
  onIncrement: () => {},
};

IncrementalButton.propTypes = {
  className: pt.string,
  initialCount: pt.number,
  maxValue: pt.number,
  onDecrement: pt.func,
  onIncrement: pt.func,
};
